<template>
  <Card>
    <template #content>
      <div class="mb-5">
        <h3 class="text-center">Current Inventory Accuracy: {{ accuracy }}%</h3>
      </div>
      <div style="height: 6rem"></div>
      <PieChart :chartData="chartData" :options="chartOptions" :height="400" />
    </template>
  </Card>
</template>

<script>
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)
import { computed, onMounted, ref, watch } from "vue"
import { PieChart } from 'vue-chart-3'
import Card from 'primevue/card'
import LocationComponentsService from '@/services/locations/LocationComponentsService'
import statusTypes from '@/contracts/StatusTypes'

export default {
  components: { Card, PieChart },
  props: {
    program: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const locationComponentsService = new LocationComponentsService()
    const chartOptions = ref()
    const inventory = ref({ statuses: [], stages: [] })

    const chartData = computed(() => ({
      labels: ['Current', 'Active', 'Missing'],
      datasets: [
        {
          data: [
            0,
            inventory.value.statuses[statusTypes.active],
            inventory.value.statuses[statusTypes.current] - inventory.value.statuses[statusTypes.active],
          ],
          backgroundColor: ['#0079AF', '#79AF00', '#FFB408']
        },
        {
          data: [
            inventory.value.statuses[statusTypes.current],
            0,
            0,
          ],
          backgroundColor: ['#0079AF']
        },
      ]
    }))

    const accuracy = computed(() => {
      return (inventory.value.statuses[statusTypes.active] / inventory.value.statuses[statusTypes.current] * 100).toFixed(2)
    })

    onMounted(() => {
      locationComponentsService.program(props.program.id).then(handleInventoryResponse)
    })

    watch(
      () => props.program,
      () => locationComponentsService.program(props.program.id).then(handleInventoryResponse)
    )

    const handleInventoryResponse = response => inventory.value = response

    return {
      accuracy,
      chartData,
      chartOptions,
    }
  },
}
</script>
